import {
  AGENT_ROLES_OPTIONS,
  FILTER_OPERATOR_ENUMS,
  FILTER_RULE_ENUMS,
} from '@constants';
import { formatDate } from '@utils';
import { omit } from 'lodash-es';

export const normalizeAgents = (data = []) => {
  const agentsData = data?.map((item) => {
    return {
      ...item,
      role: AGENT_ROLES_OPTIONS[`is${item?.role}`]?.text || '',
    };
  });

  return agentsData;
};

const agentMapping = (agents, email) => {
  const agent = agents?.find((item) => item?.value === email);
  return agent?.text || email || '-';
};

export const getEmailTemplatesRequestPayload = (payload = {}) => {
  const fields = omit(payload, ['page', 'pageSize']) || {};

  const mapFields = {
    status: 'status',
  };

  const multyFilterNumberFields = ['status'];

  const getValue = ({ field }) => {
    if (multyFilterNumberFields?.includes(field)) {
      return payload[field]?.split(',').map((item) => Number(item));
    }
    return payload[field];
  };

  const getType = ({ field }) => {
    if (multyFilterNumberFields?.includes(field)) {
      return FILTER_RULE_ENUMS.IsAnyOfRuleType;
    }
    return FILTER_RULE_ENUMS.ComparableRuleType;
  };

  const value = [
    ...Object.keys(fields).map((field) => ({
      field: mapFields[field] || field,
      operator: FILTER_OPERATOR_ENUMS['='],
      type: getType({ field }),
      value: getValue({ field }),
    })),
  ];

  if (value.length) {
    return {
      type: FILTER_RULE_ENUMS.AndRuleType,
      field: null,
      operator: null,
      value,
    };
  }

  return {
    type: FILTER_RULE_ENUMS.EmptyRuleType,
  };
};

export const handleEmailTemplatesData = (data = [], agents = []) => {
  if (!data) {
    return [];
  }

  return data?.map((item) => ({
    ...item,
    createdAt: item?.createdAt
      ? formatDate(item?.createdAt, 'dd/MM/yyyy')
      : '-',
    createdBy: item?.createdBy ? agentMapping(agents, item?.createdBy) : '-',
    status: item?.status ? 'Active' : 'Inactive',
  }));
};

export const handleEmailTemplate = (data = {}, agents = []) => {
  if (!data) {
    return {};
  }

  return {
    bodyGr: data?.body?.gr || '',
    bodyEn: data?.body?.en || '',
    createdAt: data?.createdAt
      ? formatDate(data?.createdAt, 'dd/MM/yyyy')
      : '-',
    createdBy: data?.createdBy ? agentMapping(agents, data?.createdBy) : '-',
    id: data?.id || '',
    name: data?.name || '',
    status: data?.status ? 'Active' : 'Inactive',
    subjectGr: data?.subject?.gr || '',
    subjectEn: data?.subject?.en || '',
    updatedAt: data?.updatedAt
      ? formatDate(data?.updatedAt, 'dd/MM/yyyy')
      : '-',
    updatedBy: data?.updatedBy ? agentMapping(agents, data?.updatedBy) : '-',
    attachmentGr: data?.attachments?.gr?.map((att) => ({
      ...att,
      persisted: true,
    })),
    attachmentEn: data?.attachments?.en?.map((att) => ({
      ...att,
      persisted: true,
    })),
  };
};
